<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>Signature</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog($event)" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="m-0">
  <div class="row reset-row">
      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 p-0 left-part">
          <form [formGroup]="signatureForm">
              <div class="sign-container">
                  <div class="d-flex align-items-center">
                      <div class="eip-pr-10 ff-2 fs-12 black"> Edit Signature</div>
                      <div class="divider-container"><span class="black">|</span></div>
                      <div class="fs-12 ff-2 white eip-ml-10 eip-pr-10">
                          <i class="fa fa-plus-circle eip-pr-2" aria-hidden="true" (click)="createSignature()"></i>
                          New Signature
                      </div>
                      <div class="fs-12 ff-2 white eip-pr-10">
                          <input matInput formControlName="txtSignatureName" class="border-bottom" *ngIf="isNew">
                      </div>
                      <div class="flex-grow-1 text-right eip-mt-2"><span class="back-white"><i class="fa fa-save" aria-hidden="true" (click)="saveSignature()"></i></span></div>
                  </div>
              </div>
              <div class="sign-editor">
                  <kendo-editor [value]="signatureText" formControlName="editor" style="height: 245px;">
                      <kendo-toolbar>
                          <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                          <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                          <kendo-toolbar-buttongroup>
                              <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                          </kendo-toolbar-buttongroup>
                          <kendo-toolbar-buttongroup>
                              <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                          </kendo-toolbar-buttongroup>
                          <kendo-toolbar-buttongroup>
                              <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                          </kendo-toolbar-buttongroup>
                          <kendo-toolbar-buttongroup>
                              <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                              <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                          </kendo-toolbar-buttongroup>
                      </kendo-toolbar>
                  </kendo-editor>
              </div>
          </form>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 p-0 right-part">
          <div class="search-container">
              <p class="fs-12 white eip-pt-3">Search</p>
          </div>
          <div class="sign-wrapper" *ngFor="let sign of signatureList; let index = index">
              <div class="main-sign">
                  <span><span class="num">{{index+1}}</span><span class="signone ff-2 fs-12">{{sign.signatureName}}</span></span>
              </div>
              <div class="d-flex">
                  <div class="sign-content" [innerHTML]="sign.signatureText">
                  </div>
                  <div class="eip-pt-10 edit-hover flex-grow-1 text-right eip-mt-2">
                      <i class="fa fa-pencil eip-mr-10" title="Edit" (click)="editSignature(sign)" aria-hidden="true"></i>
                      <i class="fa fa-trash eip-mr-10" title="Delete" (click)="deleteSignature(sign)" aria-hidden="true"></i>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button class="btn btn-primary" id="btnSave" (click)="postSignature()"><i class="fa fa-check-circle" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Ok</button>
      <button class="btn btn-secondary" id="btnReset" (click)="reset()"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Clear</button>
  </div>
</div>